import {ServerAuthenticationEntryPoint} from './types.js';
import {HttpStatus} from "../../http/status.ts";

const DEFAULT_REALM = "Realm";
const createHeaderValue = (realm: string): string => {
    return `Basic realm="${realm}"`;
}

export const httpBasicEntryPoint = (opts?: { realm?: string }): ServerAuthenticationEntryPoint => {
    const headerValue = createHeaderValue(opts?.realm ?? DEFAULT_REALM);
    return async (exchange, _error) => {
        const {response} = exchange;
        response.setStatusCode(HttpStatus.UNAUTHORIZED);
        response.headers.set("WWW-Authenticate", headerValue);
    };
}
